export {
  CREATE_NEXT_APP_VERSION,
  SAFE_EMPTY_FILES,
  buildCreateNextAppArgs,
  isScaffoldableEmptyDir,
  resolvePackageManager,
  runCreateNextApp,
  type PackageManager,
} from './scaffold.js';
